export default "__VITE_ASSET__wN2_g6r3__"